export default __webpack_public_path__ + "static/media/Manage Your Health.7dba7bf6.svg";